export default class SweepManager {

    _sweeps = new Set();

    _sweepCollectionCallbacks = [];

    constructor(sdk) {
        this._sdk = sdk;

        sdk.Sweep.data.subscribe({
            onCollectionUpdated: this._handleSweepCollectionUpdated.bind(this),
        });
    }

    addSweep(sweepId) {
        this._sweeps.add(sweepId);
    }

    async hideUnknown() {
        const sweepCollection = await this.getSweepCollection();

        const hiddenSweeps = [...sweepCollection].filter(sweep => !this._sweeps.has(sweep[0]))
                                                 .map(sweep => sweep[0]);
        this._sdk.Sweep.disable(...hiddenSweeps);
    }

    async getSweepCollection() {
        return new Promise(resolve => {
            if (this._sweepCollection != null) {
                resolve(this.__sweepCollection);
                return;
            }

            this._sweepCollectionCallbacks.push(() => resolve(this._sweepCollection));
        });
    }

    // Sweep Events

    _handleSweepCollectionUpdated(collection) {
        this._sweepCollection = collection;

        this._sweepCollectionCallbacks.forEach(callback => callback());
        this._sweepCollectionCallbacks = [];
    }

}
